import { memo } from "react";
import { Image } from "react-native";

const lomanRobotGreen = require("../../assets/lomanrobot_green.png");
const lomanRobotWhite = require("../../assets/lomanrobot_white.png");
const lomanRobotBlack = require("../../assets/lomanrobot_black.png");

const LomanRobot = ({
  size,
  color = "black",
  className = "",
}: {
  size: number;
  color?: "white" | "green" | "black";
  className?: string;
}) => {
  return (
    <Image
      source={
        color === "white"
          ? lomanRobotWhite
          : color === "green"
            ? lomanRobotGreen
            : color === "black"
              ? lomanRobotBlack
              : lomanRobotBlack
      }
      style={{ width: size, height: size }}
      resizeMode="contain"
      className={className}
    />
  );
};

export default memo(LomanRobot);
